export function getLocalStorageItems(key, defaultData = []) {
  return JSON.parse(localStorage.getItem(key)) || defaultData;
}

export function setLocalStorageItems(key, data) {
  localStorage.setItem(key, JSON.stringify(data));
}
